import { render, staticRenderFns } from "./EventFinishPage.vue?vue&type=template&id=14794132&"
import script from "./EventFinishPage.vue?vue&type=script&lang=js&"
export * from "./EventFinishPage.vue?vue&type=script&lang=js&"
import style0 from "./EventFinishPage.vue?vue&type=style&index=0&id=14794132&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports